export const PROCESSOR_DASHBOARD_DATA = 'PROCESSOR_DASHBOARD_DATA';
export const ADD_PROCESSOR_DATA = 'ADD_PROCESSOR_DATA';
export const ADD_PROCESSOR_API = 'ADD_PROCESSOR_API';
export const PROCESSOR_DASHBOARD_LENGTH = 'PROCESSOR_DASHBOARD_LENGTH';
export const CHECK_MAPPING = 'CHECK_MAPPING';
